__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "grmShell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "21.2.7", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(614), __webpack_require__.e(770), __webpack_require__.e(613), __webpack_require__.e(204)]).then(() => (() => (__webpack_require__(6613))))));
			register("@angular/common", "21.2.7", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(614), __webpack_require__.e(352)]).then(() => (() => (__webpack_require__(1352))))));
			register("@angular/core", "21.2.7", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(518)]).then(() => (() => (__webpack_require__(518))))));
			register("@angular/forms", "21.2.7", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(614), __webpack_require__.e(44), __webpack_require__.e(456), __webpack_require__.e(271)]).then(() => (() => (__webpack_require__(4456))))));
			register("@angular/platform-browser", "21.2.7", () => (Promise.all([__webpack_require__.e(614), __webpack_require__.e(44), __webpack_require__.e(950), __webpack_require__.e(895), __webpack_require__.e(823)]).then(() => (() => (__webpack_require__(4895))))));
			register("@angular/router", "21.2.7", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(614), __webpack_require__.e(770), __webpack_require__.e(44), __webpack_require__.e(415), __webpack_require__.e(293), __webpack_require__.e(76), __webpack_require__.e(442)]).then(() => (() => (__webpack_require__(7415))))));
			register("rxjs", "7.8.2", () => (Promise.all([__webpack_require__.e(770), __webpack_require__.e(76), __webpack_require__.e(201)]).then(() => (() => (__webpack_require__(7201))))));
			register("tslib", "2.8.1", () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(4398))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};